import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
let ContactConsensiModel = (_dec = attr('string'), _dec2 = attr('boolean'), _dec3 = attr('string'), _dec4 = attr('boolean', {
  defaultValue: false
}), _class = class ContactConsensiModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "option_name", _descriptor, this);
    _initializerDefineProperty(this, "accepted", _descriptor2, this);
    _initializerDefineProperty(this, "accepted_date", _descriptor3, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "option_name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "accepted", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "accepted_date", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ContactConsensiModel as default };
//# sourceMappingURL=contact-consensi.js.map
